import type { Site } from '../Site';

export const PricePandaTH: Site = {
  id: 'pricepandath',
  logo: '',
  label: 'PricePanda TH',
  analyticsName: 'pricepandath',
  hostname: 'pricepanda.co.th',
  platform: 'responsive',
  selector: 'main a',
};
